import { render, staticRenderFns } from "./UniversityExamUpdateScore.vue?vue&type=template&id=81ba2800&scoped=true"
import script from "./UniversityExamUpdateScore.vue?vue&type=script&lang=js"
export * from "./UniversityExamUpdateScore.vue?vue&type=script&lang=js"
import style0 from "./UniversityExamUpdateScore.vue?vue&type=style&index=0&id=81ba2800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ba2800",
  null
  
)

export default component.exports